/**
 * `learning-blocks` — motor de bloques de aprendizaje EXTENSIBLE de Aula.
 *
 * Adding a new block type = implement `BlockPlugin` + `registry.register()`.
 * The engine (`gradeBlock`/`gradeLesson`) NEVER changes. See LEARNING_BLOCKS guide.
 */
export * from "./types";
export * from "./normalize";
export * from "./registry";
export * from "./engine";
export * from "./antifraud";
export * from "./blocks";

import { baseBlocks } from "./blocks";
import { BlockRegistry } from "./registry";

/** Registry preloaded with the 6 base types. Starting point for app. */
export function defaultRegistry(): BlockRegistry {
  return new BlockRegistry().registerAll(baseBlocks);
}
